// extracted by mini-css-extract-plugin
export default {"status_container":"DrmServiceConfiguration_status_container__oOh1N","status":"DrmServiceConfiguration_status__OYtFP"};